import React, { useState, useEffect, useContext } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Row, Col, Button, Table, Accordion } from "react-bootstrap";
import { Store } from "react-notifications-component";
import classes from "./AllSupplyAnalysis.module.css";
import EditSupplyModal from "../Modals/EditSupplyModal.jsx";
import ReactExport from "react-export-excel-fixed-xlsx";
import { Divider } from "rsuite";
import PermissionContext from "../../../Store/permission-context";

const AllSupplyAnalysis = (props) => {
  const ExcelFile = ReactExport.ExcelFile;
  const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
  const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
  const PCtx = useContext(PermissionContext);
  const [AxiosError, setAxiosError] = useState("");
  const [RetrievedSupplyRecords, setRetrievedSupplyRecords] = useState([]);
  const [Title, setTitle] = useState("");
  const [SentRecord, setSentRecord] = useState([]);
  const [DisplayData, setDisplayData] = useState(false);
  const [ShowModal, setShowModal] = useState(false);
  const [IsPrinting, setIsPrinting] = useState(false);

  useEffect(() => {
    let Records = props.Records;
    setRetrievedSupplyRecords(Records);
    setDisplayData(true);

    if (props.myDates.type === "specific") {
      setTitle((" for " + props.myDates.dates).toUpperCase());
    } else {
      let thedates = [...props.myDates.dates];
      setTitle(
        (
          "from " +
          thedates[0] +
          " to " +
          thedates[thedates.length - 1] +
          "."
        ).toUpperCase()
      );
    }
  }, []);

  const PrintTheReport = () => {
    setIsPrinting(true);
    window.print();
    setIsPrinting(false);
  };

  const bringModal = (ir) => {
    console.log(ir);
    setSentRecord(ir);
    setShowModal(true);
  };

  const cancelModal = () => {
    setShowModal(false);
  };

  const getTableCode = (ArrData, ind) => {
    let DataPresent = true;
    if (
      ArrData.ThisSupplyRecords != undefined &&
      ArrData.ThisSupplyRecords.length > 0
    ) {
      DataPresent = true;
    } else {
      DataPresent = false;
    }

    return (
      <Row className="justify-content-around mt-3" key={ind}>
        <Col md={12} sm={11} xs={11}>
          <Accordion.Item eventKey={ind}>
            <Accordion.Header>
              {" "}
              SUPPLY REPORT OF {ArrData.ThisDate.toUpperCase()}
            </Accordion.Header>
            <Accordion.Body>
              {DataPresent &&
                ArrData.ThisSupplyRecords.map((tsr, index) => (
                  <div key={index}>
                    <Divider style={{ fontSize: "17px", color: "black" }}>
                      {"Supply from " + tsr.TheSupplier}
                    </Divider>
                    <Table striped bordered responsive key={index}>
                      <thead>
                        <tr>
                          <th>SN</th>
                          <th>Good Name</th>
                          <th>Quantity (Bulk)</th>
                          <th>Quantity (Unit)</th>
                          <th>Cost Price</th>
                          <th>Total Cost Price</th>
                          <th>Received By</th>
                          <th>Supplier</th>
                          <th>Date_Supplied</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tsr.TheTable.map((rec, index) => (
                          <tr key={index}>
                            <td>{index > tsr.length - 1 ? index + 1 : ""}</td>

                            <td>{rec.GoodName}</td>
                            <td>{rec.QBulk}</td>
                            <td>{rec.QUnit}</td>
                            <td>{rec.CostPrice}</td>
                            <td>{rec.TotalCostPrice}</td>
                            <td>{rec.Receiver}</td>
                            <td>{rec.Supplier}</td>
                            <td>{rec.DateSupplied}</td>
                            <td>
                              <Button
                                variant="info"
                                className="btn-sm"
                                onClick={() => bringModal(rec, index)}
                              >
                                Edit
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                ))}
              {!DataPresent && (
                <p style={{ color: "Red", fontSize: "15px" }}>
                  Oops! No Record for {ArrData.ThisDate}
                </p>
              )}
            </Accordion.Body>
          </Accordion.Item>
        </Col>
      </Row>
    );
  };

  const SaveNewSupplyRecord = async (newrec) => {
    let Response = await PCtx.connectAxios("updatesupplyrecords.php", newrec);
    if (!Response.includes("Error")) {
      setShowModal(false);
      props.Reload();
      PCtx.displayAlert(
        "SUCCESS",
        newrec.NGoodName +
          " supply properties have been edited successfully and the report has been reloaded for the changes to be effected.",
        "success"
      );
    }
  };

  const ExportToExcel = (ArrData, datess) => {
    return (
      <ExcelSheet data={ArrData} name={datess}>
        <ExcelColumn label="GOOD NAME" value="GoodName" />
        <ExcelColumn label="QUANTITY (BULK)" value="QBulk" />
        <ExcelColumn label="QUANTITY (UNIT)" value="QUnit" />
        <ExcelColumn label="COST PRICE" value="CostPrice" />
        <ExcelColumn label="TOTAL COST PRICE" value="TotalCostPrice" />
        <ExcelColumn label="RECEIVER" value="Receiver" />
        <ExcelColumn label="SUPPLIER" value="Supplier" />
        <ExcelColumn label="DATE SUPPLIED" value="DateSupplied" />
      </ExcelSheet>
    );
  };

  const TableForPrinting = (ArrData, indx) => {
    let DataPresent = true;
    if (
      ArrData.ThisSupplyRecords != undefined &&
      ArrData.ThisSupplyRecords.length > 0
    ) {
      DataPresent = true;
    } else {
      DataPresent = false;
    }
    return (
      <div key={indx}>
        {props.myDates.Category === "Individual" &&
          props.myDates.Staff.toUpperCase()}
        Supply REPORTS FOR {ArrData.ThisDate.toUpperCase()}
        {DataPresent &&
          ArrData.ThisSupplyRecords.map((tsr) => (
            <div>
              <Divider style={{ fontSize: "17px", color: "black" }}>
                {"Supply from " + tsr.TheSupplier}
              </Divider>
              <Table
                striped
                bordered
                responsive
                key={indx}
                className={classes.table4printing}
              >
                <thead>
                  <tr>
                    <th>SN</th>
                    <th>Good Name</th>
                    <th>Quantity (Bulk)</th>
                    <th>Quantity (Unit)</th>
                    <th>Cost Price</th>
                    <th>Total Cost Price</th>
                    <th>Received By</th>
                    <th>Supplier</th>
                    <th>Date_Supplied</th>
                  </tr>
                </thead>
                <tbody>
                  {tsr.TheTable.map((rec, index) => (
                    <tr key={index}>
                      <td>{index < tsr.length - 1 ? index + 1 : ""}</td>

                      <td>{rec.GoodName}</td>
                      <td>{rec.QBulk}</td>
                      <td>{rec.QUnit}</td>
                      <td>{rec.CostPrice}</td>
                      <td>{rec.TotalCostPrice}</td>
                      <td>{rec.Receiver}</td>
                      <td>{rec.Supplier}</td>
                      <td>{rec.DateSupplied}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ))}
        {!DataPresent && <p>Oops! No Record for {ArrData.ThisDate}</p>}
        <hr />
      </div>
    );
  };

  const ConcatenateArray = (thearray) => {
    let alltables = [];
    thearray.ThisSupplyRecords.map(
      (tsr) => (alltables = [...alltables, ...tsr.TheTable])
    );
    return alltables;
  };

  return (
    <Row className={classes.margin4printing}>
      <Col md={12} sm={12} xs={12} className={classes.margin4printing}>
        <Row className={classes.margin4printing}>
          {DisplayData && (
            <Row
              className={`${
                classes.margin4printing
              } ${"justify-content-around"}`}
            >
              <Col md={12} className={classes.hide4printing}>
                <p
                  style={{
                    fontFamily: "Times New Roman",
                    fontSize: "20px",
                    color: "brown",
                    textAlign: "center",
                  }}
                >
                  {props.myDates.Category === "Individual" &&
                    props.myDates.Staff.toUpperCase()}{" "}
                  SUPPLY REPORTS {Title}
                </p>
              </Col>

              <Col md={12} sm={12} xs={12} className={classes.margin4printing}>
                <Row
                  className={`${
                    classes.margin4printing
                  } ${"justify-content-around"}`}
                >
                  <Col
                    md={12}
                    sm={12}
                    xs={12}
                    className={classes.hide4printing}
                  >
                    <Accordion
                      defaultActiveKey={
                        props.TableToShow > -1 ? props.TableToShow : null
                      }
                    >
                      {props.myDates.type === "specific"
                        ? getTableCode(RetrievedSupplyRecords, 0)
                        : RetrievedSupplyRecords.map((rtrvrec, index) =>
                            getTableCode(rtrvrec, index)
                          )}
                    </Accordion>
                  </Col>
                  <Col
                    md={12}
                    sm={12}
                    xs={12}
                    className={classes.margin4printing}
                  >
                    {IsPrinting
                      ? props.myDates.type === "specific"
                        ? TableForPrinting(RetrievedSupplyRecords, 0)
                        : RetrievedSupplyRecords.map((rtrvrec, index) =>
                            TableForPrinting(rtrvrec, index)
                          )
                      : null}
                  </Col>
                  <hr className={`${classes.hide4printing} ${"mx-2"}`} />
                  <Col md={2} sm={6} xs={6} className={classes.hide4printing}>
                    <Button variant="info" onClick={PrintTheReport}>
                      Print
                    </Button>
                  </Col>
                  <Col md={2} sm={6} xs={6} className={classes.hide4printing}>
                    <ExcelFile
                      element={
                        <Button variant="info" className="my-2">
                          EXPORT TO EXCEL
                        </Button>
                      }
                      filename={
                        (props.myDates.Category === "Individual"
                          ? props.myDates.Staff.toUpperCase()
                          : "") +
                        " Supply REPORT FOR " +
                        (props.myDates.type === "specific"
                          ? RetrievedSupplyRecords.ThisDate
                          : RetrievedSupplyRecords[0].ThisDate +
                            "-" +
                            RetrievedSupplyRecords[
                              RetrievedSupplyRecords.length - 1
                            ].ThisDate
                        ).toUpperCase()
                      }
                    >
                      {props.myDates.type === "specific"
                        ? ExportToExcel(
                            ConcatenateArray(RetrievedSupplyRecords),
                            RetrievedSupplyRecords.ThisDate
                          )
                        : RetrievedSupplyRecords.map((rtvdata) =>
                            ExportToExcel(
                              ConcatenateArray(rtvdata),
                              rtvdata.ThisDate
                            )
                          )}
                    </ExcelFile>
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
        </Row>
      </Col>
      {ShowModal && (
        <EditSupplyModal
          cancelModal={cancelModal}
          Suprec={SentRecord}
          show={ShowModal}
          SaveNewRecord={SaveNewSupplyRecord}
        />
      )}
    </Row>
  );
};

export default AllSupplyAnalysis;
